import { render } from "./VMIImageHelp.vue?vue&type=template&id=4175c564&scoped=true"
import script from "./VMIImageHelp.vue?vue&type=script&lang=js"
export * from "./VMIImageHelp.vue?vue&type=script&lang=js"

import "./VMIImageHelp.vue?vue&type=style&index=0&id=4175c564&scoped=true&lang=scss"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4175c564"]])

export default __exports__